module.exports = __webpack_public_path__ + "img/ultra_tab_1.8b29509b.svg";